import { Injectable } from '@angular/core';
import { SaleDistributionFindInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/find/sale-distribution-find.dto';
import { SaleDistributionFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/sale-distribution-form.dto';
import { SalaryDistributionQueryInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/salary-distribution-query.dto';
import { SalaryDistributionPageInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/salary-distribution-page.dto';
import { SalaryDistributionStatInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/salary-distribution-stat.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalaryDistributionService extends BaseService {
  protected baseUrl = '/finance/document/salary-distribution';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: SalaryDistributionQueryInterface): Observable<SalaryDistributionPageInterface> {
    return this.http.get<SalaryDistributionPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public restoreOne(id: number): Observable<SaleDistributionFindInterface> {
    return this.http.post<SaleDistributionFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getStat(body: SaleDistributionFormInterface): Observable<SalaryDistributionStatInterface> {
    return this.http.post<SalaryDistributionStatInterface>(`${this.baseUrl}/stat`, body);
  }
}
